import React from 'react';
import { BrandEntriesInput, BrandEntryItem } from './BrandEntriesInput';

interface BrandEntriesFieldProps {
  label: string;
  required?: boolean;
  value?: BrandEntryItem[];
  onChange: (_value: BrandEntryItem[]) => void;
  error?: string;
}

export const BrandEntriesField: React.FC<BrandEntriesFieldProps> = ({
  label,
  required = false,
  value = [],
  onChange,
  error,
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <BrandEntriesInput value={value} onChange={onChange} />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </>
  );
};
